import React from "react";
import { Link } from 'react-router-dom';

import moment from "moment"
import { db } from "firebase/fbConfig.js"
import Button from "components/CustomButtons/Button.jsx";

const formatDate = (fsDate) => moment(fsDate.toDate()).format('MM/DD/YYYY');

const getStdOrderData = async (doc, test, dispatchers, pickUp) => {
    const docData = doc.data();

    if (Boolean(docData.test) !== test) return null;
    if (pickUp) {
        // console.log("compare " + docData.origin.date.seconds)
        const formatDate = new Date(docData.origin.date.seconds * 1000)
        // console.log("compare " + formatDate)
        const formattedDate = new Date(formatDate).toDateString()
        const finalDate = new Date(formattedDate)
        const today = new Date(new Date().toDateString())
        // console.log("pickup " + new Date(formattedDate))
        // console.log("today " + new Date(new Date().toDateString()))
        console.log("pickup " + finalDate)
        console.log("today " + today)
        console.log(finalDate > today)
        if (finalDate > today) return null
    }
    // console.log("compare " + new Date(new Date().toDateString()))
    // console.log((new Date(order.origin.date.toDateString())) > new Date(new Date().toDateString()))

    // Format firestore date into formatted moment
    const formatDate = (fsDate) => moment(fsDate.toDate()).format('MM/DD/YYYY');

    // Get best drop off date
    const serviceETA = () => {
        if (!docData.serviceETA) return "N/A";

        const typeToQuote = {
            'Air': 'air',
            'Scheduled Air': 'cargoAir',
            'Ground': 'ground',
            'LTL': 'autoLtl',
            'Additional Options': 'ltl'
        };

        const d = formatDate(docData.serviceETA);

        const quoteObj = docData[typeToQuote[docData.deliveryType]];

        if (!quoteObj) return d;

        const timeSlot = [
            quoteObj.start,
            quoteObj.end
        ].filter(Boolean).join(' - ');

        return `${d} ${timeSlot}`;
    };

    // Put commas in number
    const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const revenue = docData.totalRevenue ? parseFloat(docData.totalRevenue).toFixed(2) : 0;
    const expenses = docData.totalExpenses ? parseFloat(docData.totalExpenses).toFixed(2) : 0;
    const cmTotal = (revenue - expenses).toFixed(2);
    const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';

    let driver

    if (docData.trips) {
        driver = docData.trips[docData.trips.length - 1] ? docData.trips[docData.trips.length - 1].driver : "N/A"
    } else {
        driver =  (docData.pickUpDriver && docData.pickUpDriver.firstName) ? `${docData.pickUpDriver.firstName}${docData.pickUpDriver.lastName ? ` ${docData.pickUpDriver.lastName}` : ''}` : "N/A"
    }

    let billingCompany

    switch (docData.billingParty) {
        case "Shipper":
            billingCompany = docData.origin ? docData.origin.businessName : "";
          break;
        case "Consignee":
            billingCompany = docData.destination ? docData.destination.businessName : "";
          break;
        case "Third Party":
            billingCompany = docData.thirdParty ? docData.thirdParty.businessName : "";
      }

      let totalWeight = 0;
      let totalQuantity = 0;
      for (let i = 0; i < docData.items.length; i++) {
        const wpp = parseInt(docData.items[i].weight ? docData.items[i].weight : 0);
        const qty = parseInt(
          docData.items[i].quantity ? docData.items[i].quantity : 0
        );
        totalWeight += wpp * qty;
        totalQuantity += qty
      }

    return {
        actions: (
            <Link to={{
                pathname: `/order/${doc.id}`,
                state: {
                    shipperID: doc.id,
                    status: docData.status
                }
            }}>
                <Button
                    color="primary"
                    fullWidth
                >DETAILS</Button>
            </Link>
        ),
        freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
        createdAt: docData.createdAt ? formatDate(docData.createdAt) : (docData.bookedAt ? formatDate(docData.bookedAt) : (docData.updatedAt ? formatDate(docData.updatedAt) : "N/A")),
        status: docData.status ? docData.status : "N/A",
        driverName: driver,
        originBusinessName: docData.origin ? docData.origin.businessName : "",
        originCity: docData.origin ? docData.origin.city + ", " + docData.origin.state : "",
        destinationBusinessName: docData.destination ? docData.destination.businessName : "",
        destinationCity: docData.destination ? docData.destination.city + ", " + docData.destination.state : "",
        billingParty: billingCompany,
        deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
        pickUpDate: docData.origin ? formatDate(docData.origin.date) : "N/A",
        dropOffDate: docData.serviceETA ? serviceETA() : (docData.destination ? formatDate(docData.destination.date) : "N/A"),
        actualDeliveredAt: (docData.actualDeliveredAt ? (docData.actualDeliveredAt ? moment(docData.actualDeliveredAt.toDate()).format('MM/DD/YYYY') : "N/A") : " ") + " " + (docData.nameOfSigner ? docData.nameOfSigner : " "),
        serviceETA: serviceETA(),
        financialStatus: docData.financialStatus ? docData.financialStatus : "N/A",
        pickUpRateStatus: docData.pickUpRateStatus ? docData.pickUpRateStatus : "N/A",
        dropOffRateStatus: docData.dropOffRateStatus ? docData.dropOffRateStatus : "N/A",
        totalWeight: totalWeight ? totalWeight : "N/A",
        totalQuantity: totalQuantity ? totalQuantity : "N/A",    
        totalExpenses: "$" + commaFy(expenses),
        totalRevenue: "$" + commaFy(revenue),
        cmTotal: "$" + commaFy(cmTotal),
        cmPercent,
        isFactored: docData.isFactored ? docData.isFactored.toString() : 'false',
        isChargeback: docData.isChargeback ? docData.isChargeback.toString() : 'false',
        referenceID: ['origin', 'destination', 'thirdParty'].map(key => docData[key] ? docData[key].referenceID : "").filter(Boolean).join(', '),
        dispatcherID: dispatchers[docData.dispatcherID],
    }
}

export const formatTableOrders = (snapshot, statusesArr = [], test = false, pickUp) => new Promise(async (resolve, reject) => {
    const dispatchersSnap = await db.collection('haney-vendors').doc('SdmzdeID9QfexkQymvqU').collection('users').where('role', '==', 'Employee').get();
    const dispatchers = Object.fromEntries(dispatchersSnap.docs.map(doc => [
        doc.id,
        doc.data().name,
    ]));

    console.log(pickUp)

    const orders = await Promise.all(snapshot.docs.map(async doc => {

        const stdData = await getStdOrderData(doc, test, dispatchers, pickUp);

        return stdData;
    }));

    resolve(orders.filter(row => {
        // If statusesArr was sent, make sure data includes statuses sent
        if (row && statusesArr.length) {
            const [isIncluded, ...statuses] = statusesArr;
            return statuses.includes(row.status.toLowerCase()) === isIncluded;
        } else return row;
    }));
})

export const formatOrders = (snapshot, statusesArr = [], test = false) => new Promise(async (resolve, reject) => {
    const dispatchersSnap = await db.collection('haney-vendors').doc('SdmzdeID9QfexkQymvqU').collection('users').where('role', '==', 'Employee').get();
    const dispatchers = Object.fromEntries(dispatchersSnap.docs.map(doc => [
        doc.id,
        doc.data().name,
    ]));

    const orders = await Promise.all(snapshot.docs.map(async doc => {

        const stdData = await getStdOrderData(doc, test, dispatchers);

        const docData = doc.data();

        const totals = docData.items.reduce((prev, curr) => {
            prev.quantity += parseFloat(curr.quantity);
            prev.weight += parseFloat(curr.quantity) * parseFloat(curr.weight);
            return prev;
        }, { quantity: 0, weight: 0 });

        return {
            ...stdData,
            id: doc.id,
            totals,
            destinationState: docData.destinationState ? docData.destinationState : "",
            uid: docData.uid ? docData.uid : "N/A",
            origin: docData.origin,
            destination: docData.destination,
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? formatDate(docData.updatedAt) : "N/A",
            vendorName: (docData.vendorPickUp && docData.vendorPickUp.name) ? docData.vendorPickUp.name : "N/A",
            signingURLs: docData.signingURLs,
            settlements: docData.settlements ? docData.settlements : [],
            updatedAt: docData.updatedAt ? formatDate(docData.updatedAt) : "N/A",
            entityIDs: docData.entityIDs
        };
    }))

    resolve(orders.filter(row => {
        // If statusesArr was sent, make sure data includes statuses sent
        if (!row.status) return false;

        if (row && statusesArr.length) {
            const [isIncluded, ...statuses] = statusesArr;
            return statuses.includes(row.status.toLowerCase()) === isIncluded;
        } else return row;
    }));
})

export const formatSettlementOrders = (snapshot, statusesArr = [], test = false) => new Promise(async (resolve, reject) => {
    const dispatchersSnap = await db.collection('haney-vendors').doc('SdmzdeID9QfexkQymvqU').collection('users').where('role', '==', 'Employee').get();
    const dispatchers = Object.fromEntries(dispatchersSnap.docs.map(doc => [
        doc.id,
        doc.data().name,
    ]));

    console.log('hello')

    const orders = await Promise.all(snapshot.docs.map(async doc => {

        const stdData = await getStdOrderData(doc, test, dispatchers);

        const docData = doc.data();
        const docID = doc.id

        let totals

        if (docData.items) {
            totals = docData.items.reduce((prev, curr) => {
                prev.quantity += parseFloat(curr.quantity);
                prev.weight += parseFloat(curr.quantity) * parseFloat(curr.weight);
                return prev;
            }, { quantity: 0, weight: 0 });
        }


        let timeAged = null
        let daysAged = null
        let invoiceDate = null
        let dueDate = null
        let invoiceAmount = null
        let totalDisbursement = null
        let factoringFee = null
        let agingStatus = null
        let currentDaysAgedStatus = false
        let Days1AgedStatus = false
        let Days31AgedStatus = false
        let Days61AgedStatus = false
        let Days91AgedStatus = false

        let settlementIDs = []
        let payDates = []
        let confirmationNumbers = []
        let paymentAmount = 0
        let factoringFees = 0
        let totalDisbursements = 0

        if (docData.settlements) {
            docData.settlements.map((settlement) => (
            settlementIDs.push(settlement.tripNumber)
        ))
        docData.settlements.map((settlement) => (
            payDates.push(settlement.completeDate ? "" : moment(settlement.completeDate).format("MM/DD/YYYY"))
        ))
        docData.settlements.map((settlement) => (
            confirmationNumbers.push(settlement.confirmationNumber)
        ))
        docData.settlements.map((settlement) => (
            paymentAmount += (settlement.grossRevenue ? settlement.grossRevenue : 0)
        ))
        docData.settlements.map((settlement) => (
            factoringFees += (settlement.factoringFee ? settlement.factoringFee : 0)
        ))
        docData.settlements.map((settlement) => (
            totalDisbursements += (settlement.disbursementAmount ? settlement.disbursementAmount : 0)
        ))
        }


        if (docData.docs) {
            if (docData.docs["invoice"]) {
                timeAged = new Date().getTime() - new Date(docData.docs["invoice"].createdAt.seconds * 1000).getTime()
                daysAged = Math.round(timeAged / (1000 * 3600 * 24))    
                invoiceDate = docData.docs["invoice"] ? formatDate(docData.docs["invoice"].createdAt) : "N/A"
                //dueDate = docData.docs["invoice"] ? (Date(docData.docs["invoice"].createdAt) + 30) : "N/A"
                dueDate = moment(invoiceDate).add(30, 'days').format("MM/DD/YYYY")
                invoiceAmount = docData.docs["invoice"] ? docData.docs["invoice"].amount : "N/A"
                // totalDisbursement = invoiceAmount - (invoiceAmount * .02)
                // factoringFee = invoiceAmount - totalDisbursement
                    switch (true) {
                      case (daysAged < 31):
                        agingStatus = "Current";
                        currentDaysAgedStatus = true
                        break;
                      case (daysAged < 61):
                        agingStatus = "Past Due 1 - 30 Days";
                        Days1AgedStatus = true
                        break;
                      case (daysAged < 91):
                        agingStatus = "Past Due 31 - 60 Days";
                        Days31AgedStatus = true
                        break;
                      case (daysAged < 121):
                        agingStatus = "Past Due 61 - 90 Days";
                        Days61AgedStatus = true
                        break;
                      case (daysAged >= 121):
                        Days91AgedStatus = "Past Due > 90 Days";
                    }
           }
        }

        return {
            ...stdData,
            id: doc.id,
            totals,
            destinationState: docData.destinationState ? docData.destinationState : "",
            uid: docData.uid ? docData.uid : "N/A",
            origin: docData.origin,
            settlements: docData.settlements,
            invoiceDate: invoiceDate,
            settlementIDs: settlementIDs.toString(),
            payDates: payDates.toString(),
            confirmationNumbers: confirmationNumbers.toString(),
            dueDate: dueDate,
            daysAged: daysAged,
            invoiceType: docData.isFactored ? "Factored" : "Direct",
            invoiceAmount: "$" + invoiceAmount,
            paymentAmount: "$" + paymentAmount,
            factoringFees: "$" + factoringFees,
            totalDisbursements: "$" + totalDisbursements,
            currentDaysAgedStatus: String(currentDaysAgedStatus),
            Days1AgedStatus: String(Days1AgedStatus),
            Days31AgedStatus: String(Days31AgedStatus),
            Days61AgedStatus: String(Days61AgedStatus),
            Days91AgedStatus: String(Days91AgedStatus),
            destination: docData.destination,
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? formatDate(docData.updatedAt) : "N/A",
            vendorName: (docData.vendorPickUp && docData.vendorPickUp.name) ? docData.vendorPickUp.name : "N/A",
            signingURLs: docData.signingURLs,
            updatedAt: docData.updatedAt ? formatDate(docData.updatedAt) : "N/A",
            createdAt: docData.createdAt ? formatDate(docData.createdAt) : "N/A",
            entityIDs: docData.entityIDs
        };
    }))

    resolve(orders.filter(row => {
        // If statusesArr was sent, make sure data includes statuses sent
        if (!row.status) return false;
        
        if (row && statusesArr.length) {
            const [isIncluded, ...statuses] = statusesArr;
            return (statuses.includes(row.financialStatus.toLowerCase()) === isIncluded);
        } else return row;
    }));
})

export const getOrders = (groups, limited = true) => new Promise((resolve, reject) => {
    console.log(groups, limited);

    let ref = db.collection('haney-orders')

    // If user sent groups, query ref based on groups
    if (groups) ref = ref.where('groups', 'array-contains-any', groups);
    // Order by freightBillNumber
    ref = ref.orderBy("updatedAt", "desc");

    if (limited) ref = ref.limit(1000);

    // Get orders, use callback
    ref.get()
        .then(resolve)
        .catch(reject);
})

export const getDeposits = (groups, limited = true) => new Promise((resolve, reject) => {
    console.log(groups, limited);

    let ref = db.collectionGroup('paymentsRegister')

    // If user sent groups, query ref based on groups
    if (groups) ref = ref.where('groups', 'array-contains-any', groups);
    // Order by freightBillNumber
    // ref = ref.orderBy("updatedAt", "desc");

    if (limited) ref = ref.limit(1000);

    // Get orders, use callback
    ref.get()
        .then(resolve)
        .catch(reject);
})

export const getDatedOrders = (groups, dateField, limited = true) => new Promise((resolve, reject) => {
    // If user didn't sent groups, return empty array for orders
    console.log(groups, limited);

    let ref = db.collection('haney-orders')

    // If user sent groups, query ref based on groups
    if (groups) ref = ref.where('groups', 'array-contains-any', groups);

    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    ref = ref.where(dateField, '<=', tomorrow);
    // Order by freightBillNumber
    ref = ref.orderBy(dateField, "desc");

    if (limited) ref = ref.limit(1000);
 
    // Get orders, use callback
    ref.get()
        .then(resolve)
        .catch(reject);
})

export const getFavoritedOrders = (uid, limited = true) => new Promise((resolve, reject) => {
    console.log(uid);

    let ref = db.collection('haney-orders').where('dispatcherID', '==', uid).orderBy("freightBillNumber", "desc")

    if (limited) ref = ref.limit(1000);

    // Get orders, use callback
    ref.get()
        .then(resolve)
        .catch(reject);
})

export const getTripOrders = (uid, limited = true) => new Promise((resolve, reject) => {
    console.log("get trip orders")
    db.collection('TEST-users').doc(uid).collection('haney-groups').get()
        .then(snapshot => {
            const groups = snapshot.docs.map(doc => doc.id);

            let ref = db.collection('haney-orders').where('groups', 'array-contains-any', groups).orderBy('origin.date', 'desc');

            if (limited) ref = ref.limit(1000);

            return ref.get()
        })
        .then(snapshot => formatOrders(snapshot, [false, 'pending', 'quoted', 'delivered', 'cancel requested', 'quote declined', 'canceled', 'cancelled']))
        .then(orders => orders.filter(order => ['LTL', 'Additional Options', 'Ground'].includes(order.deliveryType)))
        .then(resolve)
        .catch(reject);
})

export const getSettlementOrders = (uid, limited = true) => new Promise((resolve, reject) => {
    console.log("get settlement orders")
    db.collection('TEST-users').doc(uid).collection('haney-groups').get()
        .then(snapshot => {
            const groups = snapshot.docs.map(doc => doc.id);

            let ref = db.collection('haney-orders').where('groups', 'array-contains-any', groups).orderBy('freightBillNumber', 'desc');

            if (limited) ref = ref.limit(1000);

            return ref.get()
        })
        .then(snapshot => formatSettlementOrders(snapshot, [true, 'factor approved and invoiced']))
        .then(orders => orders.filter(order => ['LTL', 'Additional Options', 'Ground'].includes(order.deliveryType)))
        // .then(orders => orders.filter(order => [true].includes(Boolean(order.isFactored))))
        .then(resolve)
        .catch(reject);
})


// WEBPACK FOOTER //
// ./src/tables/rows/orders.js